export default "<p>asc-code-reports works!</p>\n";